import { render } from "./BasePopup.vue?vue&type=template&id=274fcaac&scoped=true&ts=true"
import script from "./BasePopup.vue?vue&type=script&lang=ts"
export * from "./BasePopup.vue?vue&type=script&lang=ts"

import "./BasePopup.vue?vue&type=style&index=0&id=274fcaac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274fcaac"]])

export default __exports__